/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import styled, { css } from 'styled-components'

import { pxToVw } from '../../functions/units'

type Props = {
  altText?: string
  height?: number
  logo: string
}

const BrandLogo = ({ altText = '', height = 40, logo }: Props) => {
  return (
    <StyledLogoWrap $height={height}>
      <img src={logo} alt={altText} />
    </StyledLogoWrap>
  )
}

export default BrandLogo

const StyledLogoWrap = styled.div<{
  $height: number
}>`
  height: ${({ $height }) => pxToVw($height)};
  flex: 0 1 auto;

  > img {
    object-fit: cover;
    height: 100%;
  }

  ${({ theme, $height }) => css`
    ${theme.mediaQuery.mobile`
      height: ${pxToVw($height, 720)};
    `}
  `}
`
